// tomopod is the radiology product. It does not render pathology
// (WSI, PathologyShell) or endoscopy (EndoscopyShell) studies —
// those open in pathopod or endopod respectively.
//
// These stubs let the legacy multi-modality StudyViewer.tsx (forked
// in Phase 4a) continue to compile. The proper fix is to trim
// StudyViewer.tsx down to its radiology-only paths in a follow-up;
// at that point this file should be deleted.
//
// Grep target: `_wrongModality`.

import type { JSX } from "solid-js";

function WrongProduct(props: { product: string; modality: string }): JSX.Element {
  return (
    <div style={{
      "display": "flex", "flex-direction": "column",
      "align-items": "center", "justify-content": "center",
      "height": "100%", "padding": "2rem",
      "color": "#e6edf3", "background": "#0b0f19",
      "text-align": "center",
    }}>
      <div style={{ "font-size": "1.5rem", "margin-bottom": "0.5rem" }}>
        {props.modality} is not part of the tomopod product
      </div>
      <div style={{ "color": "#94A3B8", "max-width": "32rem" }}>
        tomopod is the radiology product. Open this study in <strong>{props.product}</strong>.
      </div>
    </div>
  );
}

export const WSIViewport      = (_props: any) => <WrongProduct product="pathopod" modality="Whole-slide imaging (pathology)" />;
export const PathologyShell   = (_props: any) => <WrongProduct product="pathopod" modality="Pathology" />;
export const EndoscopyShell   = (_props: any) => <WrongProduct product="endopod" modality="Endoscopy" />;

export type ProcedureType = string;
export function guessProcedure(_a?: any, _b?: any, _c?: any): ProcedureType { return "unknown"; }
